import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {ReactNode} from 'react';
import StatusNoteSection, {StatusNoteSectionProps} from '../../atoms/statusNoteSection/StatusNoteSection';

export interface StatusNoteDialogProps extends StatusNoteSectionProps {
  open: boolean;
  onClose: () => void;
  statusNote?: string | null;
  title?: string;
  headerContent?: ReactNode;
}

export default function StatusNoteDialog({
  open,
  onClose,
  statusNote,
  title = 'Status Note (JSON)',
  headerContent,
}: StatusNoteDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{fontWeight: 600, fontSize: '1.25rem'}}>{title}</DialogTitle>
      <DialogContent>
        {headerContent && <Box sx={{mb: 2}}>{headerContent}</Box>}
        <StatusNoteSection statusNote={statusNote} />
      </DialogContent>
      <DialogActions sx={{px: 3, pb: 2, pt: 1.5}}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{bgcolor: '#1B263B', '&:hover': {bgcolor: '#1B263B', opacity: 0.8}}}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
